import { render, staticRenderFns } from "./QuoteTemplateApplyModal.vue?vue&type=template&id=70a98366"
import script from "./QuoteTemplateApplyModal.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateApplyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a98366')) {
      api.createRecord('70a98366', component.options)
    } else {
      api.reload('70a98366', component.options)
    }
    module.hot.accept("./QuoteTemplateApplyModal.vue?vue&type=template&id=70a98366", function () {
      api.rerender('70a98366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuoteTemplateModal/QuoteTemplateApplyModal.vue"
export default component.exports